module.exports = __webpack_public_path__ + "img/BG Green.cf3da1e.png";